import { userAuthStore } from "@/store/auth";
import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
} from "axios";
import * as qs from "qs";

export const createAxios = function (
  config?: AxiosRequestConfig
): AxiosInstance {
  const instance = axios.create({
    baseURL: "https://bhjdapi.bhjddd.com/",
    timeout: 30000, // 超时配置
    withCredentials: true, // 跨域携带cookie
    ...config,
  });

  instance.interceptors.request.use(
    function (configs: InternalAxiosRequestConfig<any>) {
      const queryParams = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
      });
      // console.log(
      //   "query params========",
      //   JSON.stringify(window.location.search)
      // );

      const newConfigs = { ...configs };
      const common = userAuthStore();
      const newToken = queryParams?.token ?? null;
      // console.log("newToken", newToken, queryParams);
      if (newToken) {
        common.authToken = newToken;
        newConfigs.headers.token = newToken;
        // console.log("no token 111111111111111", common.authToken);
      } else {
        // console.log("request token ", common.authToken);
        newConfigs.headers.token = common.authToken;
      }
      // console.log("request config---->>>>", JSON.stringify(newConfigs));
      // console.log(
      //   "request config- params--->>>>",
      //   JSON.stringify(newConfigs.params)
      // );
      return newConfigs;
    },
    function (error: any) {
      // 请求错误
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    function (response: any) {
      console.log("response response------->>>", JSON.stringify(response));
      if (response.data.status === 2) {
        window?.flutter_inappwebview?.callHandler("reLogin", null);
        window?.DFlutter?.postMessage("reLogin");
        return Promise.reject(response?.data?.info ?? "账号异常");
      } else if (response.data.status === 506) {
        return Promise.reject({
          statusCode: response.data.status,
          errorInfo: response?.data?.info ?? "数据异常",
        });
      } else if (response.data.status !== 0) {
        return Promise.reject(response?.data?.info ?? "数据异常");
      }
      return response?.data?.data;
    },
    function (error) {
      console.log("response error--------->><<>>", JSON.stringify(error));
      return Promise.reject(error);
    }
  );

  return instance;
};
